import { Component, Input, OnInit } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { IBaryInput } from 'models/bary-input';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BaryValidator } from '../../../../validators/bary.validator';
import { CommonModule } from '@angular/common';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';

@Component({
  selector: 'jhi-bary-input-email',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective],
  templateUrl: './bary-input-email.component.html',
})
export class BaryInputEmailComponent implements IBaryInput, OnInit {
  @Input() id = '';
  @Input() label?: string;
  @Input() icon?: string;
  @Input() name?: string;
  @Input() counter = false;
  @Input() disabled = false;
  @Input() multiEmail = false;
  @Input() control: FormControl<string | null> = new FormControl('');

  ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    this.multiEmail ? this.control.addValidators(BaryValidator.multiEmail()) : this.control.addValidators(Validators.email);
  }
}
